/** Ids de columna. No uses "acciones": useSharedTable la manda siempre al inicio. */
export const COLUMNAS_PRODUCTO_SELECCIONADO = {
  numero: "numero",
  clave: "clave",
  producto: "nombre",
  tipoProducto: "tipo_producto",
  precioUnitario: "precio_unitario",
  cantidad: "cantidad",
  unidad_medida: "unidad_medida",
  comentario: "comentario",
  total: "precio_total",
  eliminar: "eliminar",
} as const;

export const ENCABEZADOS_PRODUCTO_SELECCIONADO = {
  numero: "#",
  clave: "Clave",
  producto: "Producto",
  tipoProducto: "Tipo producto",
  precioUnitario: "P. Unitario",
  cantidad: "Cantidad",
  unidad_medida: "U. medida",
  comentario: "",
  total: "Total",
  eliminar: "",
} as const;

export const ETIQUETA_TOTAL_PEDIDO = "Total del pedido:";
export const MENSAJE_SIN_PRODUCTOS = "Aún no agregas productos";

/**
 * useSharedTable siempre pagina en modo cliente. Como esta lista no muestra
 * paginador, se usa una página grande para que ningún producto quede oculto.
 */
export const TAMANO_PAGINA_PRODUCTOS = 10;
export const TAMANO_PAGINA_SIN_PAGINADOR = 100;

export const ANCHO_MINIMO_TABLA_PRODUCTOS = 600;
export const COLOR_TOTAL_PEDIDO = "#084d6e";

//comentarios en tabla de productos seleccionados
export const CLAVES_COMENTARIO_OBLIGATORIO = ["PN-C-NI", "PN-A-NI"];
export const MAX_COMENTARIO = 255;
export const MENSAJE_COMENTARIO_OBLIGATORIO = "Este producto requiere comentario";